<template>
  <Layout>
    <div v-if="!show_ie">
      <!-- <Appdowload></Appdowload> -->
      <div class="bordertop3">
        <div class="header">
          <HeaderNav name="3"></HeaderNav>
        </div>
        <div>
          <div class="exam" :style="list.length<=4?'height:900px':''">
            <div class="exam-bar">
              <ul>
                <a v-for="(cate,key) in cate_list" :key="key">
                  <li
                    @click="changeTab(key)"
                    class="inlineblock exam-bar-item"
                    :class="{active:cate_id==cate.id}"
                  >{{cate.category_name}}</li>
                </a>
              </ul>
            </div>
            <div class="train-sub-bar" v-if="cate_list[cate_key]">
              <div class="sub-ul">
                <span>分类：</span>
                <div
                  v-for="(sub_tab,index) in cate_list[cate_key].child" :key="index"
                  @click="changeSubTabId(sub_tab.id)"
                  class="inlineblock train-bar-item sub_item"
                  :class="{active:sub_tab_id==sub_tab.id}"
                >
                  <div class="pointer">{{sub_tab.category_name}}</div>
                </div>
              </div>
            </div>
            <div style="margin-top: 25px;">
              <div class="exam-list">
                <div v-for="(item,item_key) in list" :key="item_key" class="exam-list-item">
                  <router-link :to="{path:'/online/detail',query:{id:item.id}}">
                    <div class="img">
                      <img :src="item.image_url[0]" />
                    </div>
                    <div class="detail">
                      <h1 class="text-nowrap">{{item.course_name}}</h1>
                      <div>
                        <div class="flt price">￥{{item.course_price}}</div>
                        <div class="flr class-hour">{{item.reply}}人购买</div>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
              <div v-if="total==0">
                <Norecord></Norecord>
              </div>
              <div style="padding-top:20px;">
                <Pages :total="total" :pagechange="change" :size="12" :current="page"></Pages>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- :style="list.length<=4?'position: fixed;bottom:0':''" -->
      <FooterDes :parentToChild="cate_list"></FooterDes>
    </div>
    <HintIE v-if="show_ie"></HintIE>
  </Layout>
</template>

<script>
import "swiper/dist/css/swiper.css";
import Swiper from "swiper";
import { getData, set_cache_item } from "../../../static/js/util.js";
import config from "../../../static/js/myconfig";
import headernav from "../../components/HeaderNav";
import footer from "../../components/FooterDes";
import pages from "../../components/Page";
import norecord from "../../components/NoRecord";
import Appdowload from "../../components/Appdowload";
import HintIE from "../../components/HintIE";
export default {
  components: {
    Appdowload: Appdowload,
    HeaderNav: headernav,
    FooterDes: footer,
    Pages: pages,
    Norecord: norecord,
    HintIE: HintIE
  },
  data() {
    return {
      cate_id: "",
      cate_key:0,
      cate_list: [],
      sub_tab_id:"",
      sub_category_id:"",
      list: [],
      total: -1,
      page: 1,
      show_ie: false,
      isfirstload:true,
    };
  },
  methods: {
    isIE() {
      if (!!window.ActiveXObject || "ActiveXObject" in window) this.show_ie = true; //不支付IE
    },
    change: function(page) {
      window.scrollTo({//置顶
        top:0
      })
      this.page = page;
      this.getOnlineCourseList(this.cate_id, page);
    },
    changeTab: function(key) {
      this.cate_key = key;
      this.cate_id = this.cate_list[key].id;
      if (
        this.cate_list[key].child != undefined &&
        this.cate_list[key].child.length > 0
      ) {
        this.changeSubTabId(this.cate_list[key].child[0].id);
      } else {
        this.changeSubTabId(0);
      }
    },
    changeSubTabId: function(sub_tab_id) {
      this.sub_tab_id = sub_tab_id;
      if (sub_tab_id == 0) {
        this.list = [];
      } else {
        this.getOnlineCourseList(sub_tab_id,1);
      }
    },
    getOnlineCourseCateList: function() {
      var that = this;
      getData(config.apimethod.getOnlineCourseCateList_v2, function(res) {
        var data = res.data;
        that.cate_list = data;
        that.cate_id = data[0].id;
        that.cate_key = 0;
        that.sub_tab_id = data[0].child[0].id;
        that.getOnlineCourseList(that.cate_id, 1);

      });
    },
    getOnlineCourseList: function(cate_id, page) {
      var that = this;
      if (cate_id == undefined) {
        cate_id = 0;
      }
      that.page = page;
      getData(
        config.apimethod.getOnlineCourseList_v2 +
          "?page=" +
          page +
          "&category_id=" +
           this.cate_id+ "&sub_category_id="+ this.sub_tab_id +"&size=12",
        function(res) {
          that.list = res.data.data;
          that.total = res.data.total;
        }
      );
    }
  },
  mounted() {
    this.getOnlineCourseCateList();
    this.isIE();
  }
};
</script>

<style>
.indexnews .newslist {
  border: none;
  padding: 0 16px;
}
.indexnews .ivu-card-body {
  padding: 0;
}
.abstit {
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  text-align: center;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 5px 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/online/index.vue